
<template>
  <div>
    <div id="testVideo" ref="box" :class="{ Fullscreen: isFullscreen }">
      <video
        id="video"
        preload="auto"
        @click="clickPlay()"
        @dblclick="dblclickPlay()"
        x5-video-player-type="h5"
        x5-video-orientation="landscape"
        webkit-playsinline="true"
        playsinline="true"
        ref="video"
      >
        <source type="video/mp4" />
      </video>
      <!-- 底部控制器 -->
      <div class="menu" :class="{ hidemenu: !showfooterControls }">
        <ul>
          <li class="playStatus">
            <img
              src="./../../../assets/school/play.png"
              v-if="isPlayEnd || !isPlay"
              @click="play()"
            />
            <img
              src="./../../../assets/school/pause.png"
              v-else
              @click="paused()"
            />
          </li>
          <li class="time">{{ currentTime | formatSeconds }}</li>
          <li id="menubackRate">
            <van-slider
              v-model="currentTimeLength"
              @change="onChange"
              @drag-start="onChangeStart"
              @drag-end="onChangeEnd"
              bar-height="4px"
              active-color="linear-gradient(81deg, #B6D3FF 0%, #4E7DF7 100%)"
              inactive-color="rgba(225,225,225,.2)"
            >
              <template #button>
                <div class="custom-button"></div>
              </template>
            </van-slider>
          </li>
          <li class="time">{{ duration | formatSeconds }}</li>
          <li @click="isPlaybackRate()" class="rateImg">
            <img
              src="./../../../assets/school/bs0.5.png"
              v-if="activePlaybackRate == 0.5"
            />
            <img
              src="./../../../assets/school/bs1.0.png"
              v-if="activePlaybackRate == 1"
            />
            <img
              src="./../../../assets/school/bs1.25.png"
              v-if="activePlaybackRate == 1.25"
            />
            <img
              src="./../../../assets/school/bs1.5.png"
              v-if="activePlaybackRate == 1.5"
            />
            <img
              src="./../../../assets/school/bs2.0.png"
              v-if="activePlaybackRate == 2"
            />
          </li>
          <li>
            <img
              src="./../../../assets/school/fullscreen.png"
              v-if="!isFullscreen"
              @click="screen()"
            />
            <img
              src="./../../../assets/school/Exitfullscreen.png"
              v-else
              @click="noScreen()"
            />
          </li>
        </ul>
      </div>
      <!-- 倍速 -->
      <ul class="playbackRate" v-if="showPlaybackRate">
        <li
          v-for="(item, index) in playbackRateList"
          :key="index"
          @click="playbackRate(item)"
          :class="{ active: item == activePlaybackRate }"
        >
        <span> x {{ item }}</span>
        </li>
      </ul>
      <!-- 记忆播放提示 -->
      <div class="shoot" v-if="showshootTip">
        <span>您上次观看{{ shootTime | formatSeconds }}，已为您自动续播</span>
        <van-icon name="close" @click="showshootTip = false" />
      </div>
      <!-- 开始播放 -->
      <div class="overlayImg" v-if="!isPlay || isPlayEnd">
        <!-- 开始播放 -->
        <img
          src="./../../../assets/school/videoplay.png"
          v-if="!isPlay && !isPlayEnd"
          @click="play()"
        />
        <!-- 重新播放 -->
        <img
          src="./../../../assets/school/videocb.png"
          v-if="isPlayEnd"
          @click="play()"
        />
      </div>
      <!-- 试看结束 -->
      <div class="trySee" v-if="!isAddStudyCenter && showtrySeeContent">
        <p>试看结束，前往APP后可继续学习</p>
        <span @click="joinStudy()">前往APP</span>
      </div>
      <!-- 倍速切换提示 -->
      <div class="Ratetip" v-if="isShowRatetip">
        <p>切换为{{ activePlaybackRate }}倍速</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    id: {
      default: 0,
    },
    // 是否加入学习中心
    isAddStudyCenter: {
      type: Boolean,
      default: false,
    },
    //续播时间
    shootTime: {
      default: 0,
    },
    //试看时间
    trySeeTime: {
      default: 0,
    },
  },
  data() {
    return {
      isIOS: false,
      isPlay: false, //是否播放中
      isPlayEnd: false, //是否播放结束
      showPlaybackRate: false, //是否显示倍速选项
      showfooterControls: true, //是否显示底部控制条
      showtrySeeContent: false, //是否显示试看提醒
      duration: 0, //总时长
      currentTime: 0, //当前时常
      currentTimeLength: 0, //已播放进度条长度
      // shootTime: 20, //续播时间
      // trySeeTime:60,//试看时间
      showshootTip: false, //是否显示续播提示
      playbackRateList: [0.5, 1, 1.25, 1.5, 2], //倍速配置项
      activePlaybackRate: 1, //当前选择的倍速
      Media: {}, //video
      setTimeoutHidefooterControls: {}, //隐藏底部控制条计时器
      position: { x: 0, y: 0 },
      lastPositionX: 0,
      isFullscreen: false, //是否全屏
      isShowRatetip: false, //是否显示倍速提示
    };
  },
  filters: {
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result =
        "" +
        (parseInt(secondTime) < 10
          ? "0" + parseInt(secondTime)
          : parseInt(secondTime));

      // if (minuteTime > 0) {
      result =
        "" +
        (parseInt(minuteTime) < 10
          ? "0" + parseInt(minuteTime)
          : parseInt(minuteTime)) +
        ":" +
        result;
      // }
      // if (hourTime > 0) {
      result =
        "" +
        (parseInt(hourTime) < 10
          ? "0" + parseInt(hourTime)
          : parseInt(hourTime)) +
        ":" +
        result;
      // }
      return result;
    },
  },
  mounted() {
    let that = this;
    var u = navigator.userAgent;
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // this.isPlayEnd = false;
    this.Media = document.getElementById("video");
    this.reloadSrc(this.src);
    // 视频初次加载
    this.Media.onloadeddata = (e) => {
      that.duration = parseInt(e.target.duration);
      if (that.shootTime) {
        that.Media.currentTime = that.shootTime;
        if (that.shootTime > 0) {
          that.showshootTip = true;
          setTimeout(() => {
            that.showshootTip = false;
          }, 6000);
        }
      }
    };
    // 播放持续触发
    this.Media.ontimeupdate = (e) => {
      that.currentTime = parseInt(e.target.currentTime);
      that.currentTimeLength = (that.currentTime / that.duration) * 100;
      // 试看结束
      if (that.trySeeTime > 0 && !that.isAddStudyCenter) {
        if (that.currentTime >= that.trySeeTime) {
          that.showtrySeeContent = true;
          that.paused();
          that.noScreen();
        }
      }
    };
    // 视频暂停
    this.Media.onpause = (e) => {
      that.showfooterControls = true;
      that.isPlay = false;
      that.$emit("suspend", that);
      // 视频暂停并且加入学习中心，保存学习进度
      if (that.isAddStudyCenter || that.trySeeTime == 0) {
        that.updateProcess();
      }
    };
    this.Media.onplaying = (e) => {
      that.hidefooterControls();
      that.isPlay = true;
      that.$emit("play", that);
    };
    // 播放结束
    this.Media.onended = (e) => {
      that.isPlayEnd = true;
      that.isPlay = false;
      that.$emit("playEnd", that);
    };
    // 视频播放错误
    this.Media.onerror = (e) => {
      // 进行容错处理
    };
  },
  methods: {
    // 重新加载路径
    reloadSrc(url) {
      this.paused();
      this.$refs.video.src = url;
      this.$refs.video.load();
    },
    // 开始播放
    play() {
      this.Media.play();
      this.isPlay = true;
      if (this.isPlayEnd) {
        this.isPlayEnd = false;
      }
    },
    // 暂停
    paused() {
      this.Media.pause();
      this.isPlay = false;
      clearTimeout(this.setTimeoutHidefooterControls);
    },
    // 全屏
    screen() {
      let box = this.$refs.box;
      if (box.requestFullscreen) {
        box.requestFullscreen();
      } else if (box.mozRequestFullScreen) {
        /* Firefox */
        box.mozRequestFullScreen();
      } else if (box.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        box.webkitRequestFullscreen();
      } else if (box.msRequestFullscreen) {
        /* IE/Edge */
        box.msRequestFullscreen();
      }

      let video = this.$refs.video;
      if (video.webkitEnterFullScreen) {
        video.webkitEnterFullScreen();
      }

      if (!this.isIOS) {
        this.isFullscreen = true;
      }
    },
    // 退出全屏
    noScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
      this.isFullscreen = false;
    },
    isPlaybackRate() {
      this.showfooterControls = false;
      this.showPlaybackRate = true;
      this.$emit("showRate");
    },
    // 倍速播放
    playbackRate(num) {
      this.Media.playbackRate = num;
      this.activePlaybackRate = num;
      this.showPlaybackRate = false;
      this.$emit("hideRate");
      this.isShowRatetip = true;
      setTimeout(() => {
        this.isShowRatetip = false;
      }, 2000);
    },
    // 单击显示隐藏控制条
    clickPlay() {
      this.showPlaybackRate = false;
      this.$emit("hideRate");
      clearTimeout(this.setTimeoutHidefooterControls);
      this.showfooterControls = !this.showfooterControls;
      if (this.showfooterControls) {
        this.hidefooterControls();
      }
    },
    // 双击开始暂停
    dblclickPlay() {
      // console.log("shuangji");
      if (this.isPlay) {
        this.paused();
      } else {
        this.play();
      }
    },
    // 隐藏底部控制条
    hidefooterControls() {
      if (this.isPlay) {
        this.setTimeoutHidefooterControls = setTimeout(() => {
          this.showfooterControls = false;
        }, 3000);
      }
    },
    // 拖动快进快退
    onChange(value) {
      // console.log(value);
      this.Media.currentTime = (this.duration * value) / 100;
    },
    onChangeStart() {
      this.paused();
    },
    onChangeEnd() {
      this.play();
    },
    // 加入学习
    joinStudy() {
      this.$emit("joinStudy");
    },
    // 记录进度
    updateProcess() {
      this.$api
        .post("school/member/update/learning/process", {
          courses_id: this.id, //类型：Number  必有字段  备注：课程id
          total_length: this.duration, //类型：Number  必有字段  备注：视频、音频、图文总长度
          breakpoint: this.currentTime, //类型：Number  必有字段  备注：视频、音频、图文播放断点
        })
        .then((res) => {
          // console.log('保存进度成功')
        });
    },
  },
};
</script>

<style scoped>
#testVideo {
  width: 100%;
  height: 202px;
  background-color: black;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

#testVideo video {
  /* width: 100%; */
  height: 211px;
}
.Fullscreen video {
  height: auto !important;
}
.menu {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 50px;
  /* background-image: linear-gradient(
    180deg,
    transparent,
    rgba(0, 0, 0, 0.37),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0.75)
  ); */
  background-color: rgba(0, 0, 0, 0.5);
  visibility: visible;
  opacity: 1;
  transition: all 500ms;
  z-index: 99;
}
.Fullscreen .menu {
  bottom: 20px;
}
.hidemenu {
  bottom: -50px;
  opacity: 0;
  visibility: hidden;
}
.menu ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 11px;
}
.menu ul li {
  width: 24px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin: 0 5px;
}
.menu ul li img {
  width: 24px;
  height: 24px;
}
.menu ul .time {
  width: 65px;
  font-size: 11px;
}
/* 进度条 */
.menu ul #menubackRate {
  flex: 1;
  height: 5px;
  position: relative;
  background-color: hsla(0, 0%, 100%, 0.3);
}
.menu .custom-button {
  width: 8px;
  height: 14px;
  background: linear-gradient(180deg, #86b4fc 0%, #4e7df7 100%);
  border-radius: 6px;
}

/* 倍速 */
.playbackRate {
  position: absolute;
  /* top: 50%;
  transform: translateY(-50%); */
  /* bottom: 50px; */
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  z-index: 999;
  display: flex;
  flex-direction: column;
  width: 30%;
  height: 100%;
}
.playbackRate li {
  flex: 1;
  /* height: 40px; */
  /* line-height: 40px; */
  text-align: center;
  color: white;
  align-self:center;
  display: flex;
  align-items: center;
}
.playbackRate .active {
  color: #4e7df7;
}
/* 记忆播放 */
.shoot {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 5px 10px;
  border-radius: 13px;
  color: white;
  position: absolute;
  bottom: 50px;
  left: 0px;
  z-index: 998;
}
.shoot span {
  margin-right: 10px;
}

/*  overlayImg*/
.overlayImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 998;
}
.overlayImg img {
  width: 66px;
  height: 46px;
}
/* trySee */
.trySee {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 998;
}
.trySee p {
  font-size: 14px;
  color: #ffffff;
  margin: 0 0 25px;
}
.trySee span {
  width: 125px;
  height: 40px;
  background: linear-gradient(90deg, #f6e7b9 0%, #e4c083 100%);
  border-radius: 22px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  color: #404247;
}

.Ratetip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.5);
}

:webkit-full-screen {
  width: 100%;
  height: 100%;
}

video:webkit-media-control {
  display: none !important;
}
</style>